import {StringChunk} from "../../chunks/types/StringChunk";

const RE_EXTRACTOR = /^\s*"(.*)"\s*$/

export function getStringFromStringChunk(
  stringChunk: StringChunk
): string {
  const capture = stringChunk.captures[0];
  const matches = RE_EXTRACTOR.exec(capture);
  return matches
    ? matches[1].replace("\\\"", "\"")
    : capture;
}
